import { workspaceRefOf } from '@onestep/camel-api';

import type { IClinic } from '@/hooks/useCurrentClinic';

const API_ROOT = '/api';

const apiPath = (...segments: readonly (string | number)[]) => `${API_ROOT}/${segments.join('/')}`;

export const camelWorkspaceScope = <T extends string | undefined>(workspaceUuid: T) =>
  ['camel', 'workspace', workspaceUuid] as const;

export const camelWorkspacePath = (workspaceUuid: string, ...segments: readonly string[]) =>
  apiPath(...camelWorkspaceScope(workspaceUuid), ...segments);

export const camelWorkspaceRef = (clinic: Pick<IClinic, 'uuid' | 'name'>) => workspaceRefOf(clinic);

export const requireWorkspaceRef = (workspaceRef: string | undefined) => {
  if (!workspaceRef)
    throw new Error('this request is workspace-scoped and needs a selected workspace');
  return workspaceRef;
};

export const dashboardsOrgScope = <T extends string | null | undefined>(orgSlug: T) =>
  ['dashboards', orgSlug] as const;

export const dashboardsOrgPath = (orgSlug: string, ...segments: readonly string[]) =>
  apiPath(...dashboardsOrgScope(orgSlug), ...segments);
